import { render, staticRenderFns } from "./Chatbot.vue?vue&type=template&id=6781e1c6&"
import script from "./Chatbot.vue?vue&type=script&lang=js&"
export * from "./Chatbot.vue?vue&type=script&lang=js&"
import style0 from "./Chatbot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports